// extracted by mini-css-extract-plugin
export default {"container":"Cca-z","oos":"Dca-z","oosUx":"Eca-z","selected":"Fca-z","labelOos":"Gca-z"};